import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core'
import { FormBuilder, FormArray, FormControl, Validators } from '@angular/forms'
import { Item, Tools } from '../../../../models'

@Component({
  selector: 'app-order-form-com',
  templateUrl: './order-form.com.html'
})

export class OrderFormComponent implements OnChanges {

  @Input() item: Item = null
  @Input() channels: string[] = null
  @Input() customers: string[] = null
  @Output() event = new EventEmitter()
  model = {
    con: { status: 'none' },
    selDate: new Tools().beijingDate(),
    items: <Item[]> [],
    itemFieldCount: 2
  }
  form = null

  constructor(private fb: FormBuilder) {}

  ngOnChanges(): void {
    if (this.item && this.model.items.every(x => x.item_id !== this.item.item_id) && this.channels) {
      this.model.items.push(this.item)
      this.item = null
      this.buildForm()
    }
  }

  public cancel(e): void {
    e.preventDefault()
    this.event.emit({ source: 'order-form', action: 'cancel' })
  }

  public submit(e): void {
    e.preventDefault()
    const order = {}
    const items = []
    Object.keys(this.form.controls).forEach(key => {
      if (key !== 'items' && key !== 'order_id' && key !== 'date') {
        order[key] = this.form.controls[key].value
      }
    })
    order['date'] = this.form.value.date
    const controls = this.form.controls['items'].controls
    controls.forEach((control, index) => {
      if (index % 2 === 0) {
        items.push({
          item_id: this.model.items[index / 2].item_id,
          count: control.value,
          price: controls[index + 1].value
        })
      }
    })
    this.event.emit({ source: 'order-form', action: 'submit', data: { order: order, items: items } })
  }

  public profits(index: number): number {
    const item = this.model.items[index]
    return this.form.controls.items.controls[index * this. model.itemFieldCount + 1].value
      - item.cost * this.form.controls.items.controls[index * this.model.itemFieldCount].value
  }

  public alertClass(index: number): string {
    return this.profits(index) > 0 ? 'alert alert-success' : 'alert alert-danger'
  }

  public panelClass(index: number): string {
    return `panel panel-${this.model.items[index].locationClass}`
  }

  public removeItem(i: number) {
    this.model.items.splice(i, 1)
    this.buildForm()
  }

  private buildForm(): void {
    this.form = null
    const arr = new FormArray([])
    this.model.items.forEach((item, index) => {
      arr.push(new FormControl(1))
      arr.push(new FormControl('', Validators.required))
    })
    this.form = this.fb.group({
      order_id: [{value: '待定', disabled: true}, Validators.required],
      date: [this.model.selDate, Validators.required],
      channel: [this.channels ? this.channels[0] : '', Validators.required],
      customer: ['', Validators.required],
      shipping_fee: [0, Validators.required],
      comment: '',
      items: arr
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/forms/order-form/order-form.com.ts